import { Component, EventEmitter, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'lib-sidenav-wrapper',
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatIconModule],
  template: `
    <div class="relative flex h-full flex-col p-4 shadow-lg">
      <div class="flex justify-end">
        <button mat-icon-button (click)="closePanel.emit()" class="text-gray-500 hover:text-gray-700"
          aria-label="Close panel">
          <mat-icon>close</mat-icon>
        </button>
      </div>
      <div class="flex-1 overflow-y-auto">
        <ng-content></ng-content>
      </div>
    </div>
  `,
})
export class SidenavWrapperComponent {
  @Output() closePanel = new EventEmitter<void>();
}